<svg
  viewBox="0 0 400 76"
  class="w-full max-w-[400px]"
  role="img"
  [attr.aria-label]="ratio() | appNumber: '1.1-1'"
  data-testid="benchmark-ray"
>
  <line class="ray-axis" [attr.x1]="axisStart" y1="28" [attr.x2]="axisEnd" y2="28" />
  <rect
    class="ray-typical"
    [attr.x]="typicalStart()"
    y="20"
    [attr.width]="typicalWidth()"
    height="16"
    rx="4"
  />
  <text class="ray-tick" [attr.x]="axisStart" y="52">{{ benchmark.scaleMin }}</text>
  <text class="ray-tick" [attr.x]="typicalStart()" y="52" text-anchor="middle">
    {{ benchmark.typicalMin }}
  </text>
  <text class="ray-tick" [attr.x]="typicalEnd()" y="52" text-anchor="middle">
    {{ benchmark.typicalMax }}
  </text>
  <text class="ray-tick" [attr.x]="axisEnd" y="52" text-anchor="end">{{ benchmark.scaleMax }}</text>
  <circle class="ray-marker" [attr.cx]="markerX()" cy="28" r="7" data-testid="benchmark-marker" />
  <text
    class="ray-value"
    [attr.x]="markerX()"
    y="12"
    text-anchor="middle"
    data-testid="benchmark-marker-value"
  >
    {{ ratio() | appNumber: '1.1-1' }}
  </text>
</svg>
